import { Tour } from '../types';

export const welcomeTour: Tour = {
  id: 'welcome',
  name: 'Welcome Tour',
  trigger: 'first-login',
  priority: 10,
  steps: [
    {
      id: 'welcome-intro',
      targetSelector: null,
      title: 'Welcome to Scholar Vision!',
      description:
        "Let's take a quick tour of the tools that'll help you find and win scholarships.",
    },
    {
      id: 'welcome-browse',
      targetSelector: 'nav-browse',
      title: 'Browse Scholarships',
      description:
        'Search and filter through our scholarship database with personalized match scores.',
      placement: 'bottom',
    },
    {
      id: 'welcome-journey',
      targetSelector: 'nav-journey',
      title: 'Track Your Journey',
      description:
        'Organize scholarships in a Kanban pipeline \u2014 from Discovered to Applied.',
      placement: 'bottom',
    },
    {
      id: 'welcome-essays',
      targetSelector: 'nav-essays',
      title: 'Essay Hub',
      description:
        'Access templates, real examples, and AI writing insights to craft standout essays.',
      placement: 'bottom',
    },
    {
      id: 'welcome-profile',
      targetSelector: 'nav-profile',
      title: 'Complete Your Profile',
      description:
        'Fill out your profile to unlock personalized match scores and eligibility checks.',
      placement: 'bottom',
    },
    {
      id: 'welcome-resources',
      targetSelector: 'nav-resources',
      title: 'Rec Letters & More',
      description:
        'Our toolkit walks you through requesting strong recommendation letters \u2014 with email templates and timelines.',
      placement: 'bottom',
    },
  ],
};
